export enum InvoiceType {
    Case = "case",
    Invoice = 'invoice'
}

export enum InvoiceRegistrationErrors {
    InvalidSocialSecurityNoORBirthdate = "Invalid CSocialSecurityNo or CBirthdate",
    InvoiceAlreadyRegistered = "Invoice already registered",
    CreditorIsInactive = "Creditor is Inactive",
}

export enum TransactionCustomSettings {
  FACILITY_IDENTIFIER = "FacilityIdentifier",
  MEASURING_IDENTIFIER = "MeasuringIdentifier",
  MEASURING_IDENTIFIER_STATUS = "MeasuringIdentifierStatus",
}

export enum TransactionCustomSettingsDataType {
  FACILITY_IDENTIFIER = 3,
  MEASURING_IDENTIFIER = 3,
  MEASURING_IDENTIFIER_STATUS = 1,
}